import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import Accueil from './components/Accueil.vue'
import Mandater from './components/Mandater.vue'
import Prevoyance from './components/Prevoyance.vue'
import Formulaire from './components/Formulaire.vue'
import Contact from './components/Contact.vue'

const socket = new WebSocket("wss://api.metav3r53.com")

Vue.prototype.$send = (event, data = null) => {
  const msg = JSON.stringify({ event, data })
  if (socket.readyState === WebSocket.OPEN) {
    socket.send(msg)
  } else {
    socket.addEventListener('open', () => socket.send(msg), { once: true })
  }
}

// Logs des réponses serveur
/*socket.addEventListener('message', (msg) => {
  const { event, data } = JSON.parse(msg.data)
  console.log('WS reçu :', event, data)
})*/

// Socket disponible globalement
Vue.prototype.$socket = socket


Vue.config.productionTip = false
Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'hash',
  routes: [
    {
      path: '/',
      component: Accueil,
      name: 'accueil'
    },
    {
      path: '/mandater',
      component: Mandater,
      name: 'mandater'
    },
    {
      path: '/prevoyance',
      component: Prevoyance,
      name: 'prevoyance'
    },
    {
      path: '/contact',
      component: Contact,
      name: 'contact'
    },
    {
      path: '/formulaire/:token',
      component: Formulaire,
      name: 'formulaire'
    }
  ]
})

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
